<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5m8vzc/tc-custom/9781455609857.jpg?1737719125059" alt="This image is the cover for the book Old Creole Days, Pelican Pouch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old Creole Days, Pelican Pouch
      </h1>
      <p class="bookDescription body article font2">
        <p>These stories reflect the Creole way of life during the transitory post-Civil War period.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Cable
      </h2>
      
      <p class="authorDescription body article">Southern reformist George Washington Cable (1844-1925) has been called the most important Southern artist of the late-nineteenth century as well as the first modern Southern writer. He was the first fiction writer in the South to outwardly challenge the accepted literary tradition of the old South and its aristocracy. In his writings, he faithfully campaigned to reform the racial caste system and eradicate political corruption. Cable also touched on many other realities of the time, including violence, interracial marriage, and a vanishing Creole culture. Through his pioneering use of dialect and skill with the short-story form, Cable helped lead the local color movement of the late 1800s.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?800d03ae